/* eslint-disable css-modules/no-unused-class */
import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    combineClasses,
} from 'wanderu-css';

import Typography from '../Typography/Typography';
import {
    getAdjustedWidthHeight,
    imageDimensionPropType,
} from './utils';

import styles from './Image.scss';

function ImageCaption(props) {
    const {
        title,
        licenseText,
        licenseHref,
        notes,
        originalSource,
    } = props;

    return (
        <>
            <Typography>
                {title}
            </Typography>
            {!!licenseHref && (
                <Typography
                    className={styles.licenseLink}
                    component={A}
                    href={licenseHref}
                    target="_blank"
                    native
                >
                    {licenseText}
                </Typography>
            )}
            {!!notes && (
                <Typography>
                    {notes}
                </Typography>
            )}
            {!!originalSource && (
                <Typography
                    className={styles.licenseLink}
                    component={A}
                    href={originalSource}
                    target="_blank"
                    native
                >
                    Link to original image.
                </Typography>
            )}
        </>
    );
}

function Image(props) {
    const {
        classes: classesProp = {},
        className,
        component: Component = 'img',
        componentProps,
        caption: captionComponent,
        height,
        width,
        aspectRatio,
        metadata = {},
        captionTitle,
        captionLicense,
        ...otherProps
    } = props;
    const {
        author,
        license,
        notes,
        originalSource,
    } = metadata;
    const {
        adjustedWidth,
        adjustedHeight,
    } = getAdjustedWidthHeight(width, height, aspectRatio);

    const classes = combineClasses(styles, classesProp);
    let imageComponent = (
        <Component
            className={clsx(
                classes.root,
                className,
            )}
            height={adjustedHeight}
            width={adjustedWidth}
            {...componentProps}
            {...otherProps}
        />
    );

    const caption = !!license || !!author
        ? (
            <ImageCaption
                licenseHref={license}
                licenseText={captionLicense}
                notes={notes}
                originalSource={originalSource}
                title={`${captionTitle} ${author}`}
            />
        )
        : captionComponent;

    if (caption) {
        imageComponent = (
            <div className={classes.captionContainer}>
                {imageComponent}
                <div className={classes.caption}>
                    {caption}
                </div>
            </div>
        );
    }

    return imageComponent;
}

Image.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    aspectRatio: PropTypes.number,
    height: imageDimensionPropType,
    width: imageDimensionPropType,
    caption: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.elementType,
        PropTypes.object,
    ]),
    metadata: PropTypes.shape({
        alt: PropTypes.string,
        author: PropTypes.string,
        license: PropTypes.string,
        notes: PropTypes.string,
        originalSource: PropTypes.string,
    }),
};

export {
    Image,
    ImageCaption,
};
export default Image;
